export const DashboardCount= {
    GET_DASHBOARDCOUNT: "GET_DASHBOARDCOUNT",   
}
export const GetAllThumbnail ={
    GET_ALLTHUMBNAIL : "GET_ALLTHUMBNAIL"
}